import React from 'react';
import './TermsPage.css';

const TermsPage: React.FC = () => {
  // Replace with your actual company name and date
  const companyName = "VKS TRADERS";
  const lastUpdatedDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="terms-page-container">
      <div className="terms-content-card">
        <h1>Terms and Conditions</h1>
        <span className="last-updated">Last Updated: {lastUpdatedDate}</span>

        <p>
          Welcome to {companyName}! These Terms and Conditions ("Terms") govern your
          participation as an independent member ("Member," "you," or "your") in
          the {companyName} network marketing program (the "Program").
        </p>
        <p>
          Please read these Terms carefully. By creating an account and
          participating in our Program, you agree to be bound by these Terms and
          our Privacy Policy.
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By registering for an account, you affirm that you are of legal age in
          your jurisdiction to enter into this agreement and that you accept and
          agree to be bound by these Terms.
        </p>

        <h2>2. Independent Contractor Status</h2>
        <p>
          You acknowledge and agree that as a Member, you are an independent
          contractor and not an employee, agent, partner, or joint venturer of
          {companyName}. You are not authorized to bind the company to any
          obligation. You are solely responsible for all self-employment taxes,
          income taxes, and other tax liabilities arising from your
          participation in the Program.
        </p>

        <h2>3. User Account and Responsibilities</h2>
        <ul>
          <li>
            <strong>Account Creation:</strong> You agree to provide accurate,
            current, and complete information during the registration process.
            This includes your legal name, contact information, and valid
            banking and PAN details for the purpose of receiving payouts.
          </li>
          <li>
            <strong>Account Security:</strong> You are responsible for
            safeguarding your password and for all activities that occur under
            your account. You agree to notify us immediately of any unauthorized
            use of your account.
          </li>
        </ul>

        <h2>4. Code of Conduct</h2>
        <p>As a Member, you agree not to:</p>
        <ul>
          <li>
            Make false or misleading claims about the Program, its products, or
            the potential for earnings.
          </li>
          <li>
            Use spam or any unsolicited mass-mailing techniques to promote the
            Program.
          </li>
          <li>Engage in any illegal, fraudulent, or unethical activity.</li>
          <li>
            Use the company's name, logo, or intellectual property except as
            expressly permitted.
          </li>
          <li>
            Misrepresent your relationship with {companyName} (e.g., by claiming
            to be an employee).
          </li>
        </ul>

        <h2>5. Compensation and Payouts</h2>
        <ul>
          <li>
            <strong>Compensation Plan:</strong> Your earnings are based on your
            performance within the structure of the official {companyName}{" "}
            Compensation Plan. The company reserves the right to modify the
            Compensation Plan at any time with prior notice.
          </li>
          <li>
            <strong>Income Disclaimer:</strong> There is no guarantee of any
            income or success. Your success depends entirely on your individual
            skills, effort, and marketing abilities. Any income examples shown
            are for illustrative purposes only and are not a promise of earnings.
          </li>
          <li>
            <strong>Payouts:</strong> Payouts will be processed to the bank
            account details you provide in your profile. You are solely
            responsible for ensuring this information is accurate and up-to-date.
            {companyName} is not liable for payments sent to an incorrect
            account due to user error.
          </li>
        </ul>

        <h2>6. Termination</h2>
        <ul>
          <li>
            <strong>By You:</strong> You may terminate your account at any time
            by contacting our support team.
          </li>
          <li>
            <strong>By Us:</strong> {companyName} reserves the right to suspend
            or terminate your account immediately, without prior notice, for any
            violation of these Terms or for any conduct we deem harmful to the
            Program or other members.
          </li>
        </ul>

        <h2>7. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, {companyName} shall not be
          liable for any indirect, incidental, special, or consequential
          damages, including but not limited to, loss of profits, data, or
          goodwill, arising from your participation in the Program.
        </p>

        <h2>8. Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the
          laws of the State of Tamil Nadu, India, without regard to its conflict of law
          principles.
        </p>
      </div>
    </div>
  );
};

export default TermsPage;